import { render, staticRenderFns } from "./TournamentsList.vue?vue&type=template&id=59d2e0c4&scoped=true"
import script from "./TournamentsList.vue?vue&type=script&lang=js"
export * from "./TournamentsList.vue?vue&type=script&lang=js"
import style0 from "./TournamentsList.vue?vue&type=style&index=0&id=59d2e0c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d2e0c4",
  null
  
)

export default component.exports